import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { RootState } from 'src/modules/shared/store';

type GetTeacherManualsResponse = {
  data: {
    content: string
  }
}

export const manualPaperDigitalApi = createApi({
  reducerPath: 'manualPaperDigitalApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.jwt;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTeacherManuals: builder.query<GetTeacherManualsResponse, string>({
      query: (trajectoryId: string) => ({
        url: apiRoutesV2.getManual(trajectoryId),
        method: 'GET',
      }),
    }),
    updateTeachersManuals: builder.mutation<void, { trajectoryId: string; body: string }>({
      query: ({ trajectoryId, body }) => ({
        url: apiRoutesV2.updateManual(trajectoryId),
        method: 'PATCH',
        body: { content: body },
      }),
      transformErrorResponse: (
        response: { status: string | number },
      ) => response.status,
    }),
  }),
});

export const { useGetTeacherManualsQuery, useUpdateTeachersManualsMutation } = manualPaperDigitalApi;
